import { IApplicationState } from '../../types/redux';

export function selectMortgageFilterRealtyPrice(state: IApplicationState) {
  return state.mortgage.filterRealtyPrice;
}
